import { useQuery, UseQueryOptions, QueryKey } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { TASKASSIGNMENT_MY_TASKS_COUNTS } from "./apiRoutes";

// Response structure from Swagger
export interface PriorityCount {
  priority: string;
  count: number;
}

export interface MyTaskStatusCount {
  taskStatus: string;
  total: number;
  priorities: PriorityCount[];
}

export interface MyTaskStatusCountsResponse {
  status: number;
  error: boolean;
  count: number;
  issues: any[];
  data: MyTaskStatusCount[];
  message: string;
}

const fetchMyTaskStatusCounts = async (): Promise<MyTaskStatusCountsResponse> => {
  const response = await axiosAuth.get<MyTaskStatusCountsResponse>(
    TASKASSIGNMENT_MY_TASKS_COUNTS
  );
  return response.data;
};

export const useGetMyTaskStatusCountsQuery = (
  options?: Omit<
    UseQueryOptions<MyTaskStatusCountsResponse, Error, MyTaskStatusCountsResponse, QueryKey>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["taskStatusCounts"],
    queryFn: fetchMyTaskStatusCounts,
    ...options,
  });
};
